module.exports = __webpack_public_path__ + "img/icon-delete.e6b8e7f5b9b1662f1f93930bb24250fe.svg";